// Minnesotaänger Mini App — v1 local UI actions (dialog).
// New code (not from telegram-tt). Only the in-app error dialog survives from
// telegram-tt's ui/messages.ts; notifications/PWA/scroll animations moved to
// ui/misc.ts as no-ops.

import type { ActionReturnType } from '../../types';
import { addActionHandler } from '../../index';
import { updateMiniapp } from '../../miniapp/update';

addActionHandler('showDialog', (global, actions, { title, message }): ActionReturnType => {
  return updateMiniapp(global, (m) => ({
    ...m,
    dialog: { title, message },
  }));
});

addActionHandler('closeDialog', (global): ActionReturnType => {
  if (!global.miniapp.dialog) return undefined;
  return updateMiniapp(global, (m) => ({
    ...m,
    dialog: null,
  }));
});
